import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useSurveyId } from './useSurveyId'

const document = graphql(`
  mutation CustomerAttributeSettingsPage_CreateCustomerAttributeGroup(
    $surveyId: String!
    $name: String!
  ) {
    createCustomerAttributeGroup(surveyId: $surveyId, name: $name) {
      id
    }
  }
`)

export const useCreateCustomerAttributeGroupMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const surveyId = useSurveyId()

  return useMutation({
    mutationFn: (name) =>
      graphQLRequest({ document, variables: { surveyId, name } }),
    ...options,
  })
}
